export const PATH_BASE = '/page'; // 主路由前缀
export const PATH_LOGIN = 'login'; // 登录页

export const PATH_USER_LIST = 'user_list';
export const PATH_MAERSK_LIST = 'maersk_go_list';
export const PATH_ORDER_LIST = 'order_list';
export const PATH_HPL_ORDER_LIST = 'hpl_order_list';
export const PATH_HPL_QQ_ORDER_LIST = 'hpl_qq_order_list';
export const PATH_ONE_ORDER_LIST = 'one_order_list';
// export const PATH_MAKE_ORDER = 'make_order';
export const PATH_MAKE_ORDER_LIST = 'make_order_list';
export const PATH_MAKE_ORDER_CID = 'make_order_CID';
export const PATH_NAVIGATION_PAGES = 'navigation_pages';
// export const PATH_QUERY_ACCOUNT_LIST = 'query_account_list';
export const PATH_BOOK_ACCOUNT_LIST = 'book_account_list';
export const PATH_GO_ACCOUNT_LIST = 'go_account_list';
export const PATH_CHECK_ACCOUNT_LIST = 'check_account_list';
export const PATH_HPL_ACCOUNT_LIST = 'hpl_account_list';
// export const PATH_BOOKING = 'make_order_socket';
// export const PATH_PRE_BOOKING = 'booking';
// export const PATH_BOOKING_MORE = 'booking_more';

// export const PATH_CESHI_PAGES = 'go_ceshi_list';
// export const PATH_SHIPPING_PAGES = 'go_shipping_list';
export const PATH_API_LIST = 'api_mode';
export const PATH_CHECK_LIST = 'check_list';
export const PATH_QUERY_LIST = 'query_list';
export const PATH_CMA_QUERY_LIST = 'cma_query_list';
export const PATH_MSK_API_LIST = 'msk_api_list';
export const PATH_BOOKING_LIST = 'booking_start_list';
export const PATH_GETCMANAME_LIST = 'get_cmaname_list';
// export const PATH_CMA_LIST = 'get_cma_list';
export const PATH_HPL_LIST = 'get_hpl_list';
export const PATH_GO_LIST = 'get_go_list';
export const PATH_BOOK_TEMP_LIST = 'get_book_temp_list';
// export const PATH_CESHI_LIST = 'get_ceshi_list';
export const PATH_BASE_LIST = 'get_base_list';
export const PATH_SHIPPING_LIST = 'get_shipping_list';
export const PATH_BOOK_TASK_LIST = 'get_book_task_list';
export const PATH_BOOK_HPL_LIST = 'get_book_hpl_list';
export const PATH_BOOK_TASK_API_LIST = 'get_book_task_api_list';
export const PATH_REMIND_LIST = 'get_remined_list';
// export const PATH_ERROR_LIST = 'get_error_list';
export const PATH_BOOK_ORDER_LIST = 'book_order_list';
export const PATH_HPL_BOOK_ORDER_LIST = 'hpl_book_order_list';
export const PATH_HPL_QQ_BOOK_ORDER_LIST = 'hpl_qq_book_order_list';
export const PATH_HPL_QQ_AUTO_BOOK_ORDER_LIST = 'hpl_qq_auto_book_order_list';
export const PATH_ONE_BOOK_ORDER_LIST = 'one_book_order_list';

export const PATH_MSC_LIST = 'get_msc_list';
export const PATH_ONE_LIST = 'get_one_list';
export const PATH_OOCL_LIST = 'get_oocl_list';
